import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text, TextArea } from '@reveni-io/reveni-ui'

import PaidReasonSelector from './PaidReasonSelector/PaidReasonSelector'
import * as Styles from './styles'

const MarkAsPaidModal = ({ show, onClose, onMarkAsPaid, markingAsPaid, amount, language, currency }) => {
  const { t } = useTranslation()
  const [notes, setNotes] = useState('')
  const [paidReason, setPaidReason] = useState('')

  useEffect(() => {
    if (!show) {
      setNotes('')
      setPaidReason('')
    }
  }, [show])

  return (
    <Modal show={show} onClose={onClose} title={t('Marcar como pagado')} size="l">
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t('Elige un motivo para poder guardar cambios y marcar el pago pendiente ({{amount}}) como completado', {
            amount: new Intl.NumberFormat(language, {
              style: 'currency',
              currency: currency || 'EUR',
            }).format(amount),
          })}
        </Text>
        <PaidReasonSelector value={paidReason} onChange={e => setPaidReason(e.target.value)} />
        <Styles.NotesContainer>
          <Text type="titleS">{t('Notas')}</Text>
          <TextArea
            fullWidth
            label={t('Escribe aquí los comentarios')}
            value={notes}
            onChange={e => setNotes(e.target.value)}
            showCounter={true}
            maxLength={100}
          />
        </Styles.NotesContainer>
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Aceptar')}
            loadingLabel={t('Guardando cambios')}
            onClick={() => onMarkAsPaid(notes, paidReason)}
            loading={markingAsPaid}
            disabled={markingAsPaid || !notes || !paidReason}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default MarkAsPaidModal
